import { createStore } from 'easy-peasy';
import storeModel from './models'

const store = createStore(storeModel);

export default store;